import React from 'react';

import { NotificationContext } from './NotificationContext';

export const useNotificationContext = () => React.useContext(NotificationContext);
